export class DepositTypeProperties {
  depositTypeId: number = 0;
  //{ get; set; }
   name: string = "";
  //{ get; set; }
  status: boolean = false;
  //{ get; set; }

  creationUser: number = 0;
  //{ get; set; }
  modifyUser: number = 0;
  //{ get; set; }
    }
